<template lang="pug">
  .coach-avatar-list(:style="styleAvatarBox")
    span(:style="styleIsOverload" v-if="isOverload")
      img(:src="isOverloadImageSrc")
    span(:style="styleIsNew" v-if="isNew")
      img(:src="isNewImageSrc")
    span(:style="styleAvatar" class="coach-avatar")
</template>

<style lang="scss" scoped>
.coach-avatar-list {
  background-color: #494e5c;
  display: flex;

  .coach-avatar {
    background-size: cover;
    display: block;
    background-position: 50%;
    background-repeat: no-repeat;
    margin: auto;
  }
}
</style>

<script>
export default {
  props: {
    src: { type: String, default: '' },
    isOverload: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
  },
  computed: {
    isOverloadImageSrc() {
      return require(`@/assets/retina-images/is_overload1.png`)
    },
    isNewImageSrc() {
      return require(`@/assets/retina-images/is_new.png`)
    },
    styleAvatarBox() {
      return { width: this.avatarBoxSize(), height: this.avatarBoxSize() }
    },
    styleAvatar() {
      return {
        width: this.avatarSize(),
        height: this.avatarSize(),
        'background-image': `url('${this.src}')`,
        'background-color': this.isDefaulCoachtAvatar()
          ? 'transparent'
          : 'rgba(25, 38, 50, 0.5)',
      }
    },
    styleIsOverload() {
      return {
        position: 'absolute',
        left: '0px',
        top: `${this.isOverloadPosition()}`,
      }
    },
    styleIsNew() {
      return {
        position: 'absolute',
        left: '6px',
        top: '4px',
        margin: '0 !important',
      }
    },
  },
  methods: {
    isDefaulCoachtAvatar() {
      if (!this.src) return false
      return this.src.indexOf('default_') !== -1
    },
    avatarBoxSize() {
      var size = window.innerWidth / 2 - 1
      size = size < 186 ? 186 : size
      return `${size}px`
    },
    avatarSize() {
      var size = window.innerWidth / 2 - 1
      size = size < 186 ? 186 : size
      return this.isDefaulCoachtAvatar() ? `${size - 72}px` : `${size}px`
    },
    isOverloadPosition() {
      var size = window.innerWidth / 2 - 1
      size = size < 186 ? 186 : size
      return `${size - 24}px`
    },
  },
}
</script>
